/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes, { any } from 'prop-types';

import Utr from '../../../text/Utr';
import PlayerLookupInputV2 from './PlayerLookupInputV2';
import { getPlayerName } from '../../../../utils';
import { drawPositionTypeIds } from '../../../../utils/eventConstants';
import { isPlayerCheckedIntoDraw } from '../../../../utils/events';

import styles from '../playerSelect.scss';

const PlayerSelectV2 = (props) => {
    const {
        drawFormatType,
        match,
        playerOptions,
        playersDict,
        playersDictByMemberId,
        utrType,
        isReadOnly,
        showBye,
        position,
        onSelect,
        teamName,
        showTeamName,
        doNotMask = true,
        sportTypeId,
        drawId,
        parentDrawId,
    } = props;

    function utrByMemberId(memberId) {
        const player = playersDictByMemberId[memberId];
        return <Utr sportTypeId={sportTypeId} player={player} pbrClass={styles.pbr} force={{ ratingType: drawFormatType.value, utrType, showDecimals: true, doNotMask }} />;
    }

    let name; let
        nameMobile;
    if (match[position]?.typeId === drawPositionTypeIds.PLAYER) {
        const selectedPlayer = playersDictByMemberId[match[position].memberId];
        const seed = match[`${position}Seed`];
        const checkedInDraw = isPlayerCheckedIntoDraw(selectedPlayer, drawId);
        name = selectedPlayer ? <span className="selected-name">{seed && <small className="selected-seed">{seed}</small>}{selectedPlayer.firstName} {selectedPlayer.lastName}<small> {utrByMemberId(selectedPlayer.memberId)}</small>{checkedInDraw && <span className="utr-icon icon-check-mark-green ml4 checkin-mark" title="Player checked in" />}</span> : '';
        nameMobile = selectedPlayer ? <span className="selected-name">{seed && <small className="selected-seed">{seed}</small>}{getPlayerName(selectedPlayer.firstName, selectedPlayer.lastName, true)}<small> {utrByMemberId(selectedPlayer.memberId)}</small>{checkedInDraw && <span className="utr-icon icon-check-mark-green ml4 checkin-mark" title="Player checked in" />}</span> : '';
    } else if (match[position]?.typeId === drawPositionTypeIds.BYE) {
        name = 'Bye';
        nameMobile = 'Bye';
    } else {
        name = 'Select a player';
        nameMobile = 'Select a player';
    }

    let selectClass;
    if (!(match[position])) {
        selectClass = 'empty';
    } else if (match[position]?.typeId === drawPositionTypeIds.BYE) {
        selectClass = 'bye';
    }

    return (
        <>
            <PlayerLookupInputV2
                {...props}
                name={name}
                selectClass={`${selectClass} ${position === 'position2' ? 'mb2' : ''}`}
                utrByMemberId={utrByMemberId}
                teamName={teamName}
                showTeamName={showTeamName}
                parentClass={`d-none d-md-block`}
                drawId={drawId}
                parentDrawId={parentDrawId}
            />
            <PlayerLookupInputV2
                {...props}
                name={nameMobile}
                selectClass={`${selectClass} ${position === 'position2' ? 'mb2' : ''}`}
                utrByMemberId={utrByMemberId}
                teamName={teamName}
                showTeamName={showTeamName}
                isMobile={true}
                parentClass={`d-block d-md-none player-lookup-mobile`}
                drawId={drawId}
                parentDrawId={parentDrawId}
                data-testid={undefined}
            />
        </>
    );
};

PlayerSelectV2.propTypes = {
    drawFormatType: PropTypes.objectOf(any).isRequired,
    match: PropTypes.objectOf(any).isRequired,
    playerOptions: PropTypes.objectOf(any).isRequired,
    playersDict: PropTypes.objectOf(any).isRequired,
    playersDictByMemberId: PropTypes.objectOf(any).isRequired,
    utrType: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    showBye: PropTypes.bool.isRequired,
    position: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    teamName: PropTypes.string.isRequired,
    showTeamName: PropTypes.bool.isRequired,
    doNotMask: PropTypes.bool.isRequired,
    sportTypeId: PropTypes.number.isRequired,
    drawId: PropTypes.string.isRequired,
    parentDrawId: PropTypes.string.isRequired,
};

export default React.memo(PlayerSelectV2);
